export const longLocalDate = (culture: string, date: string): string => {
  const parsedDate = Date.parse(date)
  if (isNaN(parsedDate)) {
    return ""
  }

  return new Date(date).toLocaleDateString(culture, {
    hour12: false,
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  })
}
